import Joi from "joi-browser";

import useConfigureForm from "../../useConfigureForm";

export default useWaitForCallbackExpectedFieldForm;

export const waitForCallbackExpectedFieldSchema = {
  fieldName: Joi.string().required().label("Field Name"),
  fieldType: Joi.string().required().label("Field Type"),
  isRequired: Joi.boolean().required().label("Required"),
  description: Joi.string().allow(null, "").label("Description"),
};

export function getWaitForCallbackExpectedFieldConfigureData(
  waitForCallbackExpectedField,
) {
  return {
    fieldName: waitForCallbackExpectedField.fieldName,
    fieldType: waitForCallbackExpectedField.fieldType,
    isRequired: waitForCallbackExpectedField.isRequired,
    description: waitForCallbackExpectedField.description,
  };
}

function useWaitForCallbackExpectedFieldForm(waitForCallbackExpectedField) {
  const { formState, updateFormState, errors, validate } = useConfigureForm(
    () =>
      getWaitForCallbackExpectedFieldConfigureData(
        waitForCallbackExpectedField,
      ),
    waitForCallbackExpectedFieldSchema,
  );

  return {
    formState,
    updateFormState,
    errors,
    validate,
  };
}
